import { CatUsuariosService } from './../../servicios/cat-usuarios.service';
import { CatRolesService } from './../../servicios/cat-roles.service';
import { Component, OnInit,ViewChild } from "@angular/core";
import { FGetRolesService } from "../../servicios/f-get-roles.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatUsuarios, FGetRoles, FGetRolesInput, CatRoles } from "../../entidades/entidades";
import { Table } from 'primeng/table';


@Component({
  selector: "app-roles-a-usuarios",
  templateUrl: "./roles-a-usuarios.component.html",
  styleUrls: ["./roles-a-usuarios.component.css"],
})
export class RolesAUsuariosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  fGetRoles: FGetRoles[];
  fGetRolesGlobal: FGetRoles[] = [];
  itemsMenu: MenuItem[];
  catRoles: SelectItem[];
  catUsuarios: SelectItem[];

  usuarioSeleccionado: CatUsuarios [] = [];
  rolSeleccionado: number [] = [];

  todos: any [] = [];
  otro: any [] = [];

  item : SelectItem [] = [];
  @ViewChild('dtfGetRoles') table: Table;


  columnasTabla: any[];
  clonedFGetRoles: { [s: string]: FGetRoles } = {};
  idRolSeleccionado;
  idUsuarioSeleccionado;



  constructor(
    private fGetRolesService: FGetRolesService,
    private catRolesService: CatRolesService,
    private catUsuariosService: CatUsuariosService
  ) {}

  async ngOnInit() {
    await this.getAllFGetRoles();
    await this.getAllCatRoles();
    await this.getAllUsuarios();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridFGetRoles();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllFGetRoles();} },
    ];
    
    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {
        field: "operacion",
        header: "",
        ordenar: false,
        styleHeader: "width: 60px;",
      },
      {
        field: "Asignado",
        header: "Asignado",
        ordenar: false,
        styleHeader: "width: 80px;",
      },
      {
        field: "rol",
        header: "Rol",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
      {
        field: "nombreUsuario",
        header: "Nombre Usuario",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
      
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let fGetRolesNew = new FGetRoles();
    fGetRolesNew.cambio = true;
    fGetRolesNew.id = 0;
    this.fGetRoles.unshift(fGetRolesNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let fGetRolesEdit = event.data;
    fGetRolesEdit.cambio = true;
    fGetRolesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let fGetRolesEdit = event.data;
    let index = this.fGetRoles.findIndex(
      (obj) => obj.id === fGetRolesEdit.id
    );
    this.fGetRoles[index] = { ...this.clonedFGetRoles[fGetRolesEdit.id]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
     try {
       let fGetRolesEdit = event.data
       //Valida si hay cambios
       if (
         fGetRolesEdit.id === this.clonedFGetRoles[fGetRolesEdit.id].id &&
         fGetRolesEdit.asignado === this.clonedFGetRoles[fGetRolesEdit.id].asignado 
       ) {
         let index = this.fGetRoles.findIndex(
           (obj) => obj.id === fGetRolesEdit.id
         );
         this.fGetRoles[index] = { ...this.clonedFGetRoles[fGetRolesEdit.id] };
         return;
       }
       //Validaciones
       //throw new Error("No paso las validaciones.")

        if (fGetRolesEdit.asignado == false && this.clonedFGetRoles[fGetRolesEdit.id].asignado) {
          fGetRolesEdit.baja = true;
          fGetRolesEdit.cambio = false;
        } else {
          fGetRolesEdit.baja = false;
          fGetRolesEdit.cambio = true;
        }
  
     } catch (e) {
       this.muestraMensaje.error(e.message, "top", "center");
     } finally {
       console.log("Paso por onEditComplete");
     }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridFGetRoles() {
    let  lstRolesAUsuarios:FGetRoles[] = this.fGetRolesGlobal.filter((x) => x.baja || x.cambio);
     await this.fGetRolesService
       .UpdateRolesaUsuario(lstRolesAUsuarios)
       .toPromise();
      this.getAllFGetRoles();
  }


  // prettier-ignore
  async getAllFGetRoles() {
     try {
        
       let  objFgetRolesInput = new FGetRolesInput(); 
       objFgetRolesInput.pIdRol=null;
       objFgetRolesInput.pIdUsuario=null;
       const datoRetorno = await this.fGetRolesService
         .getRoles(objFgetRolesInput)
         .toPromise();
       this.fGetRoles = datoRetorno;
       this.fGetRolesGlobal = datoRetorno;
       console.log('fGetRolesGlobal: ',this.fGetRolesGlobal);
    
       for (var i = 0, len = this.fGetRoles.length; i < len; ++i)
         this.clonedFGetRoles[this.fGetRoles[i].id] = {...this.fGetRoles[i],        };

         this.rolSeleccionado = null;
         this.usuarioSeleccionado = null;
     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log("Paso por getAllFGetRoles");
     }
  }



  async getAllUsuarios() {
    try {
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuarios = datoRetorno.map((datos) => {
        return { label: datos.nombreUsuario, value: datos.id };
      });

      //this.catUsuarios.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {

    }
  }
  async getAllCatRoles() {
    try {
      const datoRetorno = await this.catRolesService.getAll().toPromise();
      this.catRoles = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

      //this.catRoles.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatModulos");
    }
  }
  async seleccionaRol(idRol) {
    console.log('idRol: ',idRol);
    this.idRolSeleccionado = idRol;
    
    console.log('this.item ',this.rolSeleccionado);

    this.fGetRoles = this.fGetRolesGlobal.filter(x=> this.filtraRoles( x,this.rolSeleccionado));
    console.log('fGetRoles: ', this.fGetRoles);
  }
  async seleccionaUsuario(idUsuario) {
    this.idUsuarioSeleccionado = idUsuario;
    //this.filtraRoles();
  }
  filtraRoles(itemGlobal, lstItemsSeleneccionados) 
  {
    console.log('itemGlobal.idRol: ', lstItemsSeleneccionados);
    //var lstREsultado=lstItemsSeleneccionados.filter(x=>x == itemGlobal.idRol);
    var lstREsultado = lstItemsSeleneccionados.filter(x=> x == itemGlobal.idRol);
    console.log('lstREsultado: ',lstREsultado);
     if(  lstREsultado.lenght > 0)
     {
       console.log('lstREsultado[0]: ',lstREsultado[0]);
       return lstREsultado[0];
     }

    if (this.idUsuarioSeleccionado == null && this.idRolSeleccionado != null)
    {
      // this.fGetRoles = this.fGetRolesGlobal.filter(
      //   (x) => x.idRol == this.idRolSeleccionado
      // );
    }
    else if (
      this.idUsuarioSeleccionado != null &&
      this.idRolSeleccionado != null
    )
      this.fGetRoles = this.fGetRolesGlobal.filter(
        (x) =>
          x.idRol == this.idRolSeleccionado &&
          x.idUsuario == this.idUsuarioSeleccionado
      );
    else if (
      this.idUsuarioSeleccionado != null &&
      this.idRolSeleccionado == null
    )
      this.fGetRoles = this.fGetRolesGlobal.filter(
        (x) => x.idUsuario == this.idUsuarioSeleccionado
      );
    else if (
      this.idRolSeleccionado == null &&
      this.idUsuarioSeleccionado == null
    )
      this.fGetRoles = this.fGetRolesGlobal.filter((x) => x);
  }

  onRolChange(event) {
    this.table.filter(event.value, 'idRol', 'in')
  }
  onUsuarioChange(event) {
    this.table.filter(event.value, 'idUsuario', 'in')
  }
}